import { noop } from "lodash";

import SubmitButton from "app/pages/sales-intelligence/common-components/MultiSelector/Buttons/SubmitButton";

type PanelSubmitButtonProps = {
    className?: string;
    isDisabled?: boolean;
    isLoading?: boolean;
    text: string;
    tooltipContent: string;
    onClick?(): void;
};

const PanelSubmitButton = (props: PanelSubmitButtonProps) => {
    const { className, isDisabled = false, isLoading = false, text, tooltipContent, onClick = noop } = props;

    return (
        <div className={className}>
            <SubmitButton
                dataAutomation="panel-submit-button"
                isDisabled={isDisabled || isLoading}
                isLoading={isLoading}
                onClick={onClick}
                label={text}
                tooltipContent={tooltipContent}
            />
        </div>
    );
};

export default PanelSubmitButton;
